<!-- src/components/NoteBlock.vue -->

<template>
  <div class="bg-gray-100 text-cal-4A4A4A text-sm p-4">
    <div class="flex">
      <div class="flex-grow">
        <div class="note-block-title text-xs">Note {{ utcToLocal(note.created_at) }}</div>
        <div class="note-block-body">{{ note.note }}</div>
      </div>
      <div class="note-block-edit flex flex-col space-y-1">
        <button :id="`edit-note-${note.id}`" @click="edit(note)" class="text-xs text-bold py-0.5 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2">Edit note</button>
        <button :id="`delete-note-${note.id}`" @click="deleteNote" class="text-xs text-bold py-0.5 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2">Delete note</button>
      </div>
    </div>
  </div>
</template>

<script>
import Format from "../../mixins/Format";
import WebServices from "../../services/WebServices";

export default {
  mixins: [Format],
  props: {
    note: {
      type: Object,
      required: true
    },
    // @todo move all editing logic into this component, out of ProjectView (Client&Admin)
    edit: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      projectServices: WebServices(`Projects/${this.note.project_id}/Notes`),
    }
  },
  methods: {
    deleteNote() {
      swal({
        title: "Delete note",
        text: "Are you sure you would like to delete this note?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Delete",
        closeOnConfirm: false
      }, function() {
        this.projectServices
            .remove(this.note.id)
            .then(() => {
              this.$emit('note-deleted', this.note)
              swal.close()
            });
      }.bind(this))
    }
  }
}
</script>
